import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import axios from '@axios'
import taxConfigurationGroupMaintain from './tax-configuration-group-maintain'

const getInitialState = () => ({
  ...storePagination.state(),
  taxConfigurationGroups: [],
  sorting: {
    sortBy: 'name',
    sortDesc: false,
  },
  filters: {
    name: '',
    ncm: '',
    active: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),
  modules: { taxConfigurationGroupMaintain },

  getters: {
    /** Combo da tela do produto: value é o id, label é a key que o usuário cadastrou. */
    getComboTaxConfigurationGroups(state) {
      return state.taxConfigurationGroups.map(group => ({
        ...group,
        value: group.id,
        label: group.name,
      }))
    },
  },

  mutations: {
    ...storePagination.mutations,

    SET_TAX_CONFIGURATION_GROUPS(state, taxConfigurationGroups) {
      state.taxConfigurationGroups = taxConfigurationGroups
    },

    SET_FILTER(state, filters) {
      state.filters = filters
    },

    CLEAN_STATE(state) {
      const { filters, paging, taxConfigurationGroups } = getInitialState()
      state.filters = filters
      state.paging = paging
      state.taxConfigurationGroups = taxConfigurationGroups
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchTaxConfigurationGroups({ commit, state }) {
      const response = await axios.get('/api/tax/tax-configuration-groups', {
        params: {
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          ...state.filters,
          sortBy: sorting.methods.getSorting(state),
        },
      })
      commit('SET_TAX_CONFIGURATION_GROUPS', response.data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: response.data.rowCount,
        rowsInCurrentPage: response.data.rowsInCurrentPage,
      })
    },

    /**
     * Cadastros que o produto pode usar: os restritos ao NCM dele e os sem restrição. É o que
     * alimenta o seletor da tela do produto.
     */
    async fetchTaxConfigurationGroupsAvailableForNcm({ commit }, ncm) {
      const response = await axios.get('/api/tax/tax-configuration-groups', {
        params: {
          pageSize: 0,
          pageIndex: 0,
          active: true,
          availableForNcm: ncm || undefined,
        },
      })
      commit('SET_TAX_CONFIGURATION_GROUPS', response.data.results)
    },

    /**
     * Produtos já associados ao cadastro. Retorna direto para o chamador: o modal de associação
     * não pode sobrescrever `taxConfigurationGroups`, que é a lista paginada da tela de trás.
     */
    async fetchSkusByGroupId(_, id) {
      const response = await axios.get(`/api/tax/tax-configuration-groups/${id}/skus`, {
        params: {
          pageSize: 0,
          pageIndex: 0,
        },
      })
      return response.data.results
    },

    /** Salva só o diff da associação — mesmo formato new/deleted do PUT do próprio cadastro. */
    async saveTaxConfigurationGroupSkus(_, { id, added, deleted }) {
      const response = await axios.put(`/api/tax/tax-configuration-groups/${id}/skus`, {
        new: added,
        deleted,
      })
      return response.data
    },

    setFilter({ commit }, filter) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTER', filter)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTER', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
